// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".image img[data-v-7377c45b] {\n  -o-object-fit: cover;\n     object-fit: cover;\n  height: 58px;\n}\n.smallImage[data-v-7377c45b] {\n  height: 36px !important;\n}\n.bigImage[data-v-7377c45b] {\n  width: 268px !important;\n  height: auto !important;\n}\n", ""]);
// Exports
module.exports = exports;
